document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".mobile-menu-toggle");
  const drawer = document.getElementById("mobileMenu");
  const overlay = document.getElementById("mobileMenuOverlay");
  const closeBtn = document.querySelector(".mobile-menu-close");

  // Open/close sidebar
  function openMenu() {
    drawer.classList.add("active");
    overlay.classList.add("active");
  }

  function closeMenu() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
  }

  if (toggle) toggle.addEventListener("click", openMenu);
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  if (overlay) overlay.addEventListener("click", closeMenu);

  // Accordion logic
  const accordionToggles = document.querySelectorAll(".accordion-toggle");

  accordionToggles.forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentLi = this.closest("li");
      const submenu = parentLi.querySelector("ul");

      if (submenu) {
        submenu.classList.toggle("active");
        this.classList.toggle("active");
      }
    });
  });
});
